import { FieldError, FieldValues, Path } from "react-hook-form";
import { TextArea } from "@songtradr-one/components-frontend";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { Props } from "./TextAreaField.Parts";

export const TextAreaField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  errors,
  register,
  rules,
  label,
  name,
  single,
  disabled,
  defaultValue,
  placeholder,
  readOnly,
  rows,
  initialHeight,
  maxHeight,
  onBlur,
}: Props<FormFields, FieldName>) => {
  const registrationProps = register(name, { ...rules });

  const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    registrationProps.onBlur(event);
    if (onBlur) onBlur(event);
  };

  return (
    <FormFieldWrapper $single={single} error={errors[name] as FieldError}>
      <TextArea
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        label={label}
        width="100%"
        initialHeight={initialHeight ?? `${(rows || 4) * 1.5}rem`}
        maxHeight={maxHeight}
        hasError={Boolean(errors[name])}
        {...registrationProps}
        defaultValue={defaultValue}
        onBlur={handleBlur}
      />
    </FormFieldWrapper>
  );
};
